import { createSlice } from '@reduxjs/toolkit';
import { DateTime } from "luxon";
import { WebStorageClient } from "../clients/webStorage.client";

const getInitialDate = () => {
  const savedDate = localStorage.getItem('peakSelectedDate');
  return savedDate || DateTime.now().toFormat('yyyy-MM-dd');
}

const initialState = {
  selectedDate: getInitialDate(),
};

const peakUsageSelectedDateSlice = createSlice({
  name: 'peakUsageSelectedDate',
  initialState,
  reducers: {
    setPeakUsageSelectedDateAction(state, action) {
      state.selectedDate = action.payload;
    },
  },
});

export const { setPeakUsageSelectedDateAction } = peakUsageSelectedDateSlice.actions;

export default peakUsageSelectedDateSlice.reducer;
